import { useState } from "react";

import { loadExitEmployeeStatus } from "../services/humanResourceServices";


const useManageEmployeeResignationStatus = () => {
    const [resignationStatus, setResignationStatus] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState('');
    const [selectedResignationStatus, setSelectedResignationStatus] = useState([]);

    const fetchResignationStatus = async ({ selectVal = null }) => {
        setLoading(true);
        setError(null);
        try {
            const payload = {
                action: 'SELECT_ALL',//select-all
                id_employee_resignation_status: 0,
                description: '', // Format: '2025-07-29'
                status: '',
                details: '',
                company_id: localStorage.getItem("companyid"),
                plant_id: 1,
                created_by: ''
            };
            const result = await loadExitEmployeeStatus(payload); // make sure this returns a promise

            if (result && result.length > 0) {
                if (selectVal !== '') {
                    let selectedRow = result.find((e) => e.description === selectVal);
                    if (selectedRow) {
                        setSelectedResignationStatus(selectedRow);

                    }
                }

            }
            setResignationStatus(result || []);
            setLoading(true);
        } catch (err) {
            console.error("Error loading employee exit status:", err);
            setError(err);
        } finally {
            setLoading(false);
        }
    };



    // crud operation call 

    const ResignationStatusCRUDOperation = async (payload) => {
        setLoading(true);
        setError(null);
        try {
            const result = await loadExitEmployeeStatus(payload); // make sure this returns a promise
            // setHolidays(result || []);
            if (result && result.length > 0) {
                let message = payload.id === 0 ? 'New Employee Exit Status Added Successfully' : 'Employee Exit Status Updated successfully'
                if (payload.action === 'delete') {
                    message = 'Employee Exit Status Removed Successfully';
                }
                setSuccess(message);
            }

        } catch (err) {
            console.error("Error loading employee exit status:", err);
            setError(err);
        } finally {
            setLoading(false);
        }
    }

    return {
        resignationStatus,
        loading,
        error,
        success,
        fetchResignationStatus,
        ResignationStatusCRUDOperation,
        setSuccess,
        selectedResignationStatus,
        setSelectedResignationStatus
    };
};

export default useManageEmployeeResignationStatus;